import { pubsub } from '@services';

class LocationCard extends HTMLElement {
  listItemElement = this.closest('li');
  /** @type {{ xandres_store: string, name: string, address: string, zip: string, city: string, collections: string[] }} */
  location = JSON.parse(this.getAttribute('data-location'));

  connectedCallback() {
    pubsub.subscribe('locations-filter:filter', (data) => this.handleFilter(data));
  }

  handleFilter({ checkedValues, query }) {
    // Check if search query matches any location field
    const hasMatchingQuery = !query || this.matchesSearchQuery(query);

    // Check if all selected collections are present in location
    const hasMatchingCollections = !checkedValues.length || this.matchesCollections(checkedValues);

    // Toggle visibility based on filter matches
    this.listItemElement.classList.toggle('hidden', !(hasMatchingQuery && hasMatchingCollections));
  }

  /**
   * Check if location matches search query
   * @param {string} query Search query to match against
   * @returns {boolean} Whether location matches query
   */
  matchesSearchQuery(query) {
    const normalizedQuery = query.toLowerCase();
    return Object.values(this.location).some((value) => {
      // If the value is an array, check if any of the items match the query
      if (Array.isArray(value)) {
        return value.some((item) => item.toLowerCase().includes(normalizedQuery));
      }

      // If the value is a string, check if it matches the query
      return String(value).toLowerCase().includes(normalizedQuery);
    });
  }

  /**
   * Check if location has all selected collections
   * @param {string[]} collections Collections to check for
   * @returns {boolean} Whether location has all collections
   */
  matchesCollections(collections) {
    return collections.every((value) => this.location.collections.includes(value));
  }
}

customElements.define('location-card', LocationCard);
